import { Button, Box } from '@mui/material';
import CustomModal from 'components/CustomModal/CustomModal';
import { useState, useRef } from 'react';
import ChordForm from './ChordForm';

const ChordModal = ({ open, onClose, title, submit, isEdit, chord }) => {
  const formRef = useRef();
  const [isValid, setIsValid] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const handleSubmit = async (data) => {
    await submit(data);
    onClose();
  };

  const normalizeData = (data) => {
    if (!isEdit) return;
    const normalized = {
      id: data.id,
      name: data.name,
      shortName: data.shortName,
      pattern: data.pattern.toString(),
    };

    return normalized;
  };

  return (
    <CustomModal open={open} onClose={onClose} title={title}>
      <ChordForm
        onSubmit={handleSubmit}
        defaultValues={normalizeData(chord)}
        formRef={formRef}
        setIsDirty={setIsDirty}
        setIsValid={setIsValid}
      />

      <Box
        sx={{
          display: 'flex',
          gap: '0.5rem',
          justifyContent: 'flex-end',
          marginTop: '1rem',
        }}
      >
        <Button
          variant='outlined'
          color='success'
          disabled={!isValid || !isDirty}
          onClick={() => {
            formRef.current?.dispatchEvent(
              new Event('submit', { cancelable: true, bubbles: true })
            );
          }}
        >
          {isEdit ? 'Edit' : 'Add'}
        </Button>
        <Button variant='outlined' onClick={onClose}>
          Cancel
        </Button>
      </Box>
    </CustomModal>
  );
};

export default ChordModal;
